export default __webpack_public_path__ + "assets/images/3e86a96c62bda37d5289754eb80c1361.png";